import { useEffect, useRef, useState } from "react";
import { formatDateTimeAuto, calculateWorkingHours, formatDate } from "../Utils/Utils";
import Apiservice from "../Apiservice";
import Swal from "sweetalert2";
import { findNearestSite } from "../Utils/locationUtils";

const FloaterAttendance = () => {

    const [loading, setLoading] = useState(false);
    const [currentDate, setCurrentDate] = useState("");
    const [attendanceDetails, setAttendanceDetails] = useState([]);

    const [roles, setRoles] = useState([]);
    const [dutyTypes, setDutyTypes] = useState([]);

    const staffNameRef = useRef("");
    const nricOrFinRef = useRef("");
    const countryCodeRef = useRef("+65");
    const mobileNoRef = useRef(null);

    const [siteId, setSiteId] = useState(0);
    const [roleId, setRoleId] = useState("");
    const [dutyTypeId, setDutyTypeId] = useState("");

    const [workingTime, setWorkingTime] = useState("00:00:00");
    const [timerId, setTimerId] = useState(null);
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localStorage.setItem("tz", userTimeZone);

    /* ---------------- INIT ---------------- */
    const loadPage = async () => {
        let nricOrFin = localStorage.getItem("nricOrFin");
        setLoading(true);
        if (nricOrFin !== null) {
            let data = {

                "nricOrFin": nricOrFin,
                "status": 0,
                "date": currentDate

            }
            const res = await Apiservice.FloaterAttendanceGet(data);
            if (res.success) {
                setAttendanceDetails(res.data);
            }
            console.log("res", res)
        }
        else {
            const result = await Apiservice.AttendancePageByUser();
            console.log("result", result);
            setRoles(result.data.roles || []);
            setDutyTypes(result.data.dutyTypes || []);
        }
        setLoading(false);
    };

    useEffect(() => {
        setCurrentDate(new Date().toISOString().split("T")[0]);

        loadPage();
    }, []);
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden) {
                stopWorkingTimer();
            } else {
                // Resume only if attendance still active
                if (
                    attendanceDetails.length > 0 &&
                    !attendanceDetails[0]?.exitTime
                ) {
                    startWorkingTimer(attendanceDetails[0].entryTime);
                }
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            stopWorkingTimer(); // ⛔ stop on unmount
        };
    }, [attendanceDetails]);


    /* ---------------- TIMER ---------------- */
    const startWorkingTimer = (entryTimeUtc) => {
        stopWorkingTimer();

        const entry = new Date(entryTimeUtc).getTime();

        const id = setInterval(() => {
            const diff = Date.now() - entry;
            if (diff < 0) return;

            const totalSeconds = Math.floor(diff / 1000);
            const h = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
            const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
            const s = String(totalSeconds % 60).padStart(2, "0");

            setWorkingTime(`${h}:${m}:${s}`);
        }, 1000);

        setTimerId(id);
    };

    const stopWorkingTimer = () => {
        if (timerId) {
            clearInterval(timerId);
            setTimerId(null);
        }
    };

    /* Resume timer after refresh */
    // useEffect(() => {
    //     const savedEntryTime = localStorage.getItem("attendanceEntryTime");
    //     if (savedEntryTime) {
    //         startWorkingTimer(savedEntryTime);
    //     }
    //     return () => stopWorkingTimer();
    // }, []);

    useEffect(() => {
        if (
            attendanceDetails.length > 0 &&
            !attendanceDetails[0]?.exitTime
        ) {
            startWorkingTimer(attendanceDetails[0].entryTime);
        } else {
            stopWorkingTimer();
            setWorkingTime("00:00:00");
        }

        return () => stopWorkingTimer();
    }, [attendanceDetails]);


    /* ---------------- CHECK IN ---------------- */
    const handleCheckIn = async () => {
        const staffName = staffNameRef.current?.value?.trim();
        const nricOrFin = nricOrFinRef.current?.value?.trim();
        const countryCode = countryCodeRef.current?.value?.trim();
        const mobileNo = mobileNoRef.current?.value?.trim();


        if (!staffName || !nricOrFin || !roleId || !dutyTypeId || !countryCode) {
            Swal.fire("Warning", "All fields are required", "warning");
            return;
        }
        // Allow only digits (no alphabets, no symbols)
        const mobileRegex = /^[89][0-9]{7}$/;

        if (!mobileRegex.test(mobileNo)) {
            Swal.fire(
                "Invalid Mobile Number",
                "Please enter a valid 8-digit mobile number",
                "warning"
            );
            return;
        }
        setLoading(true);


        navigator.geolocation.getCurrentPosition(async (pos) => {

            try {
                const { latitude, longitude } = pos.coords;
                let finalSiteId = siteId;

                if (!finalSiteId) {
                    const siteRes = await Apiservice.AllSites({ status: 0 });
                    const nearest = findNearestSite(latitude, longitude, siteRes.data);
                    if (!nearest) throw new Error("Not inside any site");
                    finalSiteId = nearest.id;
                }

                const formData = new FormData();
                formData.append("staffName", staffName);
                formData.append("nricOrFin", nricOrFin);
                formData.append("countryCode", countryCode);
                formData.append("mobileNo", mobileNo);
                formData.append("site_id", finalSiteId);
                formData.append("role_id", roleId);
                formData.append("dutyTypeId", dutyTypeId);
                formData.append("entryTime", currentDate)
                formData.append("entryLatitude", latitude);
                formData.append("entryLongitude", longitude);

                const res = await Apiservice.FloaterAttendanceAdd(formData);
                console.log("res", res)

                if (res.success) {
                    const entryTime = res.data[0].entryTime;

                    localStorage.setItem("attendanceEntryTime", entryTime);
                    localStorage.setItem("nricOrFin", res.data[0].nricOrFin);
                    localStorage.setItem("siteId", finalSiteId);
                    window.dispatchEvent(new Event("siteIdChanged"));
                    startWorkingTimer(entryTime);

                    setAttendanceDetails(res.data);
                    loadPage();

                    Swal.fire("Success", "Checked in successfully", "success");
                } else {
                    if (res.code === "IN_DUTY") {
                        let retrievedAttendanceDetails = res.data[0];

                        localStorage.setItem("attendanceEntryTime", retrievedAttendanceDetails.entryTime);
                        localStorage.setItem("nricOrFin", retrievedAttendanceDetails.nricOrFin);
                        localStorage.setItem("siteId", retrievedAttendanceDetails.site_id);
                        window.dispatchEvent(new Event("siteIdChanged"));
                        startWorkingTimer(retrievedAttendanceDetails.entryTime);

                        setAttendanceDetails(res.data);
                        loadPage();
                    }

                    if (res.code === "REST_NOT_COMPLETED") {
                        Swal.fire("Rest Required", res.message, "info");
                    }
                }

            } catch (err) {
                Swal.fire("Error", err.message, "error");
            } finally {
                setLoading(false);
            }

        });
    };

    /* ---------------- CHECK OUT ---------------- */
    const handleCheckOut = async (attendanceId) => {
        setLoading(true);
        navigator.geolocation.getCurrentPosition(async (pos) => {

            try {
                const { latitude, longitude } = pos.coords;

                const formData = new FormData();
                formData.append("floaterAttendanceId", attendanceId);
                formData.append("exitLatitude", latitude);
                formData.append("exitLongitude", longitude);
                formData.append("exitTime", new Date().toISOString());
                formData.append("status", 0);

                const res = await Apiservice.FloaterAttendanceUpdate(formData);
                console.log("res",res);
                if (res.success) {
                    stopWorkingTimer();
                    setWorkingTime("00:00:00");
                    loadPage();
                    localStorage.removeItem("attendanceEntryTime");
                    localStorage.removeItem("siteId");


                    Swal.fire("Success", "Checked out successfully", "success");

                    // optional: notify other components
                    window.dispatchEvent(
                        new CustomEvent("attendanceUpdated", {
                            detail: { refresh: true }
                        })
                    );
                } else {
                    throw new Error(res.message);
                }

            } catch (err) {
                Swal.fire("Error", err.message, "error");
            } finally {
                setLoading(false);
            }

        });
    };

    { console.log("floater page called") }

    /* ---------------- UI ---------------- */
    return (
        <div className="container mt-3">

            {loading && (
                <div className="text-center my-5">
                    <div className="spinner-border text-primary" />
                    <p>Please wait...</p>
                </div>
            )}

            {!loading && attendanceDetails.length === 0 && (
                <div className="card p-4 shadow rounded-4">
                    <h5 className="text-center text-primary mb-4">Attendance Check-In</h5>

                    <input
                        className="form-control mb-2"
                        placeholder="Staff Name"
                        ref={staffNameRef}
                    />

                    <input
                        className="form-control mb-2"
                        placeholder="NRIC / FIN"
                        ref={nricOrFinRef}
                    />

                    <div className="row g-2 mb-2">
                        {/* Country Code */}
                        <div className="col-4 col-md-3">
                            <input
                                className="form-control"
                                ref={countryCodeRef}
                                maxLength={4}
                                defaultValue="+65"
                                onInput={(e) => {
                                    e.target.value = e.target.value
                                        .replace(/[^0-9+]/g, '')
                                        .replace(/(?!^)\+/g, '');
                                }}
                            />
                        </div>

                        {/* Mobile Number */}
                        <div className="col-8 col-md-9">
                            <input
                                className="form-control"
                                ref={mobileNoRef}
                                placeholder="Mobile Number"
                                maxLength={10}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/\D/g, '');
                                }}
                            />
                        </div>
                    </div>


                    <select className="form-select mb-2" value={roleId}
                        onChange={e => setRoleId(e.target.value)}>
                        <option value="">Select Grade</option>
                        {roles.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
                    </select>

                    <select className="form-select mb-3" value={dutyTypeId}
                        onChange={e => setDutyTypeId(e.target.value)}>
                        <option value="">Select Duty</option>
                        {dutyTypes.map(d => <option key={d.id} value={d.id}>{d.duty}</option>)}
                    </select>

                    <button className="btn btn-success w-100" onClick={handleCheckIn}>
                        Check In
                    </button>
                </div>
            )}

            {!loading && attendanceDetails.length > 0 && !attendanceDetails[0].exitTime && (
                <div className="card p-4 shadow">
                    <h5 className="text-primary text-center mb-3">Attendance Check-Out</h5>

                    <p><b>Date:</b> {formatDate(currentDate)}</p>
                    <p><b>Site</b> {attendanceDetails[0].siteName}</p>
                    <p><b>Grade:</b> {attendanceDetails[0].roleName}</p>
                    <p><b>Duty:</b> {attendanceDetails[0].dutyType}</p>
                    <p><b>Entry Time:</b> {formatDateTimeAuto(attendanceDetails[0].entryTime)}</p>
                    <p><b>Working Time:</b> {workingTime}</p>

                    <button className="btn btn-danger w-100"
                        onClick={() => handleCheckOut(attendanceDetails[0].id)}>
                        Check Out
                    </button>
                </div>
            )}

            {!loading && attendanceDetails.length > 0 && attendanceDetails[0].exitTime && (
                <div className="card p-4 shadow">
                    <h5 className="text-primary text-center mb-3">Working Details</h5>
                    <p><b>Site</b> {attendanceDetails[0].siteName}</p>
                    <p><b>Grade:</b> {attendanceDetails[0].roleName}</p>
                    <p><b>Duty:</b> {attendanceDetails[0].dutyType}</p>
                    <p><b>Entry:</b> {formatDateTimeAuto(attendanceDetails[0].entryTime)}</p>
                    <p><b>Exit:</b> {formatDateTimeAuto(attendanceDetails[0].exitTime)}</p>
                    {
                        console.log("entryTime", attendanceDetails[0].entryTime)

                    }
                    {
                        console.log("exitTime", attendanceDetails[0].exitTime)

                    }
                    <p>
                        <b>Total Hours:</b>{" "}
                        {calculateWorkingHours(
                            attendanceDetails[0].entryTime,
                            attendanceDetails[0].exitTime
                        )}
                    </p>
                </div>
            )}
        </div>
    );
};

export default FloaterAttendance;
